import { API_URL } from "config";
import Http from "util/https";
import { CommonForm, OrderResponse, OrderBill, OrderForm, OrderGeneralSixBill, OrderSixBill, OrderTyreSixBill, RequestDirectDelivery, SearchFormApiParams, OrderResponseApi } from "../types";
import { convertUTCToDate, orderStatusFromNumber } from "../utils/common";

const checkRequestDirectDelivery = (is_direct_shipping: boolean): RequestDirectDelivery => {
  if (is_direct_shipping === true) return 'メーカー直送で納品';
  if (is_direct_shipping === false) return '物流経由で納品';
  return '';
};

/**
 * 本部用注文作成・編集取得Api
 * @param params 注文商品一覧Apiのパラメータ
 * @param isBill 伝票形式で返すかどうか
 * @returns orderList
 */
export default async function orderFormApi(params: SearchFormApiParams, isBill?: boolean) {
  const http = Http.default.alterAuth({useToken: true});
  const url = `${API_URL}/order/list/select`;
  const res = await http.post<OrderResponseApi>(url, params);

  console.log(res);

  // const res: {data: OrderResponseApi} = {
  //   data: {
  //     total: 15,
  //     order_infos: [{
  //       order_status: 0,
  //       order_no: "",
  //       order_build_no: "AA1234567899-01",
  //       item_cd: "000001",
  //       jan_cd: "0000000000001",
  //       client_cd: "000001",
  //       store_cd: "0001",
  //       store_name: "美女木店",
  //       store_stock: 1000,
  //       is_client: false,
  //       supply_type: 10000,
  //       vendor_cd: "000001",
  //       vendor_name: "ﾌﾞﾘﾁﾞｽﾄﾝ",
  //       class_name: "タイヤ",
  //       brand: "WH",
  //       item_name: "WH STA",
  //       size: "185/65R15H",
  //       maker_item_cd: "-",
  //       order_quantity: 1000,
  //       shipping_quantity: 0,
  //       is_request_to_admin: false,
  //       unit_base_price: 10000,
  //       unit_cost_price: 15000,
  //       unit_sale_price: 20000,
  //       order_date: "2025-03-03",
  //       desired_date: "2025-04-04",
  //       shipping_date: "2025-04-01",
  //       shipping_scheduled: "2025-04-01",
  //       arrival_date: "2025-04-04",
  //       client_doc_no: "-",
  //       is_set_order: true,
  //       is_staggered: true,
  //       is_customer_order: false,
  //       is_direct_shipping: false,
  //       is_direct: false,
  //       author: "鈴木 太郎",
  //       approver: '佐藤 花子',
  //       shipping_dest_cd: "000001",
  //       shipping_dest_zip: "012-3456",
  //       shipping_dest_address: "埼玉県戸田市美女木北２－１－１７",
  //       shipping_dest_tel: "000-0000-0000",
  //       order_store_fax: "000-0000-0001",
  //       shipping_dest_name: "美女木店",
  //       memo: "店舗メモです",
  //       remarks: "本部メモです",
  //     }],
  //   }
  // };
  // const orderList: OrderResponse[] = [];
  // // eslint-disable-next-line no-plusplus
  // for (let i = 0; i < 10; i++) {
  //   const order = structuredClone(res.data.order_infos[0])
  //   orderList.push(order)
  // }
  // res.data.order_infos = orderList;

  const orderBase: OrderForm[] = res.data.order_infos.map((o, i) => ({
    id: (params.offset ?? 0) + i + 1,
    clientCd: o.client_cd ?? '',
    storeCd: o.store_cd ?? '',
    orderNumber: o.order_build_no || '',
    orderPlainNumber: o.order_no || '',
    productCd: o.item_cd ?? '',
    janCd: o.jan_cd ?? '',
    orderStatus: orderStatusFromNumber(o.order_status ?? 0),
    supplierCd: o.supplier_cd ?? '',
    supplierName: o.supplier_name ?? '',
    classification: o.class_name ?? '',
    brand: o.brand_name ?? '',
    productName: o.item_name ?? '',
    size: o.size ?? '',
    productNumber: o.item_num ?? '',
    isCustomerOrder: Boolean(o.is_customer_order) ?? false,
    isDirectOrder: Boolean(o.is_direct) ?? undefined,
    orderDate: convertUTCToDate(o.order_date),
    deliveryDate: convertUTCToDate(o.desired_date),
    arrivalDate: o.arrival_date,
    orderCount: o.order_quantity || 0,
    headquartersCost: (o.order_quantity * o.unit_base_price) || 0,
    headquartersUnitCost: o.unit_base_price || 0,
    wholesalePrice: (o.order_quantity * o.unit_cost_price) || 0,
    wholesaleUnitPrice: o.unit_cost_price || 0,
    shopPrice: (o.order_quantity * o.unit_sale_price) || 0,
    shopUnitPrice: o.unit_sale_price || 0,
    productType: o.is_tire_wheel ?? undefined,
    orderCreator: o.author ?? '',
    orderApprover: o.approver ?? '',
    shopRemarks: o.memo ?? '',
    headquartersRemarks: o.remarks ?? '',
    isSet: o.is_set_order ?? false,
    isStaggered: o.is_staggered ?? false,
    confirmErrMsg: o.err_msg,
    shopName: o.store_name,
  }));

  if (isBill) {
    // 選択されている注文を六行伝票に直す => 全データフロントには持っていない（無限スクロールで途切れている場合など）ので、APIから取得する
    const selectedOrderList = (): OrderSixBill[] => {
      const orders = orderBase;
      const bills: OrderSixBill[] = orders.map((o, i) => {
        if (
          (o.productCd.startsWith('95') && (o.productCd.slice(2,4) === "02" || o.productCd.slice(2,4) === "03")) || // 代表コードの場合は商品コードでタイヤ・ホイール/一般用品を判断
          o.classification === "タイヤ" || o.classification === "ホイール" || (o.classification === '' && o.productType)
        ) { // 前後異径を含んでいればタイヤ
          const tyreBill: OrderTyreSixBill = {
            id: i+1,
            clientCd: o.clientCd,
            orderNumber: o.orderNumber,
            shopCd: o.shopCd,
            productCd: o.productCd,
            classification: o.classification,
            supplierCd: o.supplierCd,
            supplierName: o.supplierName,
            brand: o.brand,
            productName: o.productName,
            size: o.size,
            orderCount: o.orderCount,
            isSet: o.isSet,
            isStaggered: o.isStaggered,
            janCd: o.janCd,
            headquartersUnitCost: o.headquartersUnitCost,
            wholesaleUnitPrice: o.wholesaleUnitPrice,
            shopUnitPrice: o.shopUnitPrice,
            shopStock: 0,
            headquartersStock: {
              meiwa: 0,
              kasai: 0,
              tohoku: 0,
              itochu: 0,
              showa: 0
            },
            supplierStock: {
              center: 0,
              neighborhood: 0
            },
            productType: o.productType,
            shopRemarks: o.shopRemarks,
            headquartersRemarks: o.headquartersRemarks,
            supplierOptions: [],
            errors: {}
          };
          return tyreBill;
        }
        const generalBill: OrderGeneralSixBill = {
          id: i+1,
          clientCd: o.clientCd,
          orderNumber: o.orderNumber,
          orderPlainNumber: o.orderPlainNumber ?? undefined,
          shopCd: o.shopCd,
          productCd: o.productCd,
          janCd: o.janCd,
          classification: o.classification,
          supplierCd: o.supplierCd,
          supplierName: o.supplierName,
          productName: o.productName,
          orderCount: o.orderCount,
          wholesaleUnitPrice: o.wholesaleUnitPrice,
          headquartersUnitCost: o.headquartersUnitCost,
          shopUnitPrice: o.shopUnitPrice,
          headquartersStock: 0,
          shopStock: 0,
          supplierStock: {
            center: 0,
            neighborhood: 0
          },
          shopRemarks: o.shopRemarks,
          headquartersRemarks: o.headquartersRemarks,
          supplierOptions: [],
          errors: {}
        };
        return generalBill;
      })
      return bills;
    };
    const order = res.data.order_infos[0];
    const sixBillObj: OrderBill = {
      tableList: selectedOrderList(),
      commonForm: {
        customerOrder: order.is_customer_order ?? false,
        shopOrderer: order.author ?? '',
        approver: order.approver ?? '',
        requestDeliveryDate: convertUTCToDate(order.desired_date),
        expectedShippingDate: convertUTCToDate(order.shipping_scheduled),
        // requestDirectDelivery: checkRequestDirectDelivery(order.is_direct == null ? (order.is_direct_shipping == null ? order.is_direct_shipping : Boolean(order.is_direct_shipping)): Boolean(order.is_direct)), // 直送を本部で既に指定されていればそちらを、そうでなければ店舗の希望をデフォルト値として表示するよう変更。
        requestDirectDelivery: checkRequestDirectDelivery((order.is_direct_shipping == null ? order.is_direct_shipping : Boolean(order.is_direct_shipping))), // 店舗と本部で同じく直送希望判定を変える。本部確定の場合は希望ではなく直送として扱われる。
        isDirectDelivery: Boolean(order.is_direct) ?? undefined,
        clientBillNumber: order.client_doc_no ?? '',
        faxNumber: order.order_store_fax ?? '',
        shippingDestination: order.shipping_dest_cd ?? '',
        postalCd: order.shipping_dest_zip ?? '',
        destinationAddress: order.shipping_dest_address ?? '',
        phoneNumber: order.shipping_dest_tel ?? '',
        destinationName: order.shipping_dest_name ?? '',
      }
    }
    console.log('sixBillObj:', sixBillObj)
    return sixBillObj
  }

  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)})
  // return res.data;
  return {
    total: res.data.total,
    orders: orderBase
  };
}